export default __webpack_public_path__ + "static/media/hc-3.f7aa8149.mp4";